module.exports = __webpack_public_path__ + "media/images/expert-882734d80d8ecb4d85e85f3a4d03b74f.png";